import React, { Suspense } from "react";
import { Route } from "react-router-dom";

const GlanceAdjustmentMarks = React.lazy(() => import("./index"));
const GlanceAdjustmentMarkTable = React.lazy(() => import("./glanceAdjustmentMarkTable"));

export const useGlanceAdjustmentMarkRoutes = () => {
  return (
    <React.Fragment>
      <Route
        path="glanceAdjustmentMarks"
        element={
          <Suspense fallback={<div>منتظر باشید...</div>}>
            <GlanceAdjustmentMarks />
          </Suspense>
        }>
        <Route
          index
          element={
            <Suspense fallback={<div>منتظر باشید...</div>}>
              <GlanceAdjustmentMarkTable />
            </Suspense>
          }
        />
      </Route>
    </React.Fragment>
  );
};
